import axios from '../config/axiosPrivate';

export const initiateAmenitiesRequest = async (communities: number[]) => {
  const url = `/amenities/request`;

  const response = await axios.post(url, { communities });
  return response.data;
};

export const getAmenities = async (communityId: number, params: any = {}) => {
  const url = `/amenities/${communityId}`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const getAmenityCategories = async () => {
  const url = '/amenities/categories';
  const response = await axios.get(url);
  return response.data;
};

export const updateCommunityAmenity = async (communityId: number, payload: any) => {
  const url = `/amenities/${communityId}/update`;
  const response = await axios.post(url, payload);
  return response.data;
};
